import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import "./css/modalProfile.css";
import tickmodal from "../../assets/UserProfile/tickmodal.svg";
import popup_location from "../../assets/UserProfile/popup_location.svg";
import popup_mail from "../../assets/UserProfile/popup_mail.svg";
import popup_phone from "../../assets/UserProfile/popup_phone.svg";
import popup_web from "../../assets/UserProfile/popup_web.svg";

const UserProfileModal = ({
  openstatus,
  closestatus,
  confirmationName,
  TitleName,
  dematLinksandName,
}) => {
  console.log(openstatus);
  console.log(confirmationName);
  console.log(TitleName);
  console.log(dematLinksandName);

  const [open, setopen] = useState(openstatus);
  const closeModal = (reason) => {
    closestatus(reason);
    setopen(false);
  };
  console.log(open);

  const closeModalOnsave = (that) => {
    closestatus(that);
    setopen(false);
  };
  return (
    <>
      {openstatus && (
        <Dialog
          maxWidth="sm"
          open={openstatus}
          onClose={()=>closeModal('close')}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              textAlign: "center",
              fontSize: "h5.fontSize",
              fontWeight: "bold",
              textTransform: "capitalize",
            }}
          >
            {confirmationName === "dematListDetails" && (
              <p className="titlename">{TitleName}</p>
            )}

            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={()=>closeModal('close')}
            ></button>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              // sx={{ textAlign: "center" }}
            >
              {confirmationName === "delete" && (
                <div className="popupdivflexfull nopadding">
                  <p className="headerSgtartname">
                    Are you sure you want to delete this record?
                  </p>
                  <br />

                  <div className="col-12 alighncet">
                    <button
                      type="button"
                      name="button"
                      className="makewhitcolor btnInuse btn-default makewhitcolor ml-15  makewhitcolor addMargin"
                      onClick={() => closeModalOnsave("yes")}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      name="button"
                      className="makewhitcolor btnInuse btn-default makewhitcolor addMargin"
                      onClick={() => closeModalOnsave("no")}
                    >
                      No
                    </button>
                  </div>
                </div>
              )}

              {confirmationName === "success" && (
                <div className="makemargin">
                  <div className="successbox ">
                    <div className="successtxt">
                      <img src={tickmodal} className="imgsuccess" />
                      User details saved successfully
                    </div>
                  </div>
                  <div className="col-12 alighncet">
                    <button
                      type="button"
                      name="button"
                      className="makewhitcolor btnInuse btn-default makewhitcolor addMargin"
                      onClick={() => closeModalOnsave("yes")}
                    >
                      ok
                    </button>
                  </div>
                </div>
              )}

              {confirmationName === "dematRedirection" && (
                <div className="makemargin">
                  <p className="dematModalHeader">
                    You will be now redirected to {dematLinksandName}.
                  </p>

                  <div className="newfontwechange">
                    <p className="customol">
                      {" "}
                      Steps to follow after Demat Account Creation:{" "}
                    </p>
                    <ol className="customol">
                      <li>
                        Once you are redirected to the broker's page, complete
                        the e-KYC. 
                      </li>
                      <li>
                        It would take 1-2 business days to activate
                        your Demat Account (you will receive respective
                        information from the brokers).
                      </li>
                      <li>
                        Enter your DP ID and Client ID manually to complete
                        your registration process.
                      </li>
                    </ol>
                  </div>
                  <div className="col-12 alighncet">
                    <button
                      type="button"
                      name="button"
                      className="makewhitcolor btnInuse btn-default makewhitcolor addMargin"
                      onClick={() => closeModalOnsave("yes")}
                    >
                      ok
                    </button>

                    <p className="dematInfo">
                      Visit our website again to continue the journey!
                    </p>
                  </div>
                </div>
              )}

              {confirmationName === "dematListDetails" && (
                <div className="makemarginRemov">
                  <ul className="brokerage-detail-popup">
                    <li>
                      <img src={popup_location} className="img" />
                     {dematLinksandName.address?dematLinksandName.address:<br></br>}
                    </li>
                    <li>
                      <img src={popup_mail} className="img" />
                      <a >{dematLinksandName.cdsl_mail} {dematLinksandName.nsdl_mail}</a>
                    </li>
                    <li>
                      <img src={popup_phone} className="img" />
                      <a>{dematLinksandName.cdsl_contact} {dematLinksandName.nsdl_contact}</a>
                    </li>
                    {!!popup_web && 
                      <li>
                        <img src={popup_web} className="img" />
                        <a>{dematLinksandName.website?dematLinksandName.website:<br></br>}</a>
                      </li>
                    }
                  </ul>
                </div>
              )}
            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default UserProfileModal;
